import LocalizedLink from '@/components/layout/LocalizedLink'
import Card from '@/components/ui/Card'
import { Play } from 'lucide-react'
import { LocalizedString, getLocalizedValue } from '@sakeena/shared'
import { useTranslation } from 'react-i18next'

export interface Video {
  id: string
  title: LocalizedString | string
  description?: LocalizedString | string
  thumbnailUrl?: string
  videoUrl?: string
  duration?: string
  views?: number
  createdAt?: string
  topic?: string
}

interface VideoCardProps {
  video: Video
}

export default function VideoCard({ video }: VideoCardProps) {
  const { t, i18n } = useTranslation()
  const currentLang = i18n.language || 'ar'

  return (
    <LocalizedLink to={`/videos/${video.id}`} className="block group">
      <Card className="h-full overflow-hidden transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
        <div className="relative aspect-video overflow-hidden bg-gray-100">
          <img
            src={video.thumbnailUrl || '/placeholders/video.jpg'}
            alt={getLocalizedValue(video.title, currentLang)}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors flex items-center justify-center">
            <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center transform scale-90 opacity-0 group-hover:scale-100 group-hover:opacity-100 transition-all duration-300">
              <Play className="w-6 h-6 text-primary-600 fill-primary-600" />
            </div>
          </div>
          {video.duration && (
            <div className="absolute bottom-2 right-2 px-2 py-1 bg-black/70 text-white text-xs rounded">
              {video.duration}
            </div>
          )}
        </div>
        <div className="p-4">
          <h3 className="font-bold text-gray-900 dark:text-gray-100 line-clamp-1 mb-2">
            {getLocalizedValue(video.title, currentLang)}
          </h3>
          {video.description && (
            <p className="text-sm text-gray-600 dark:text-gray-400 line-clamp-2 leading-relaxed">
              {getLocalizedValue(video.description, currentLang)}
            </p>
          )}
          <div className="mt-4 flex items-center justify-between text-xs text-gray-500">
            {video.topic && <span>{video.topic}</span>}
            {video.views !== undefined && (
              <span>
                {video.views} {t('common.views', 'مشاهدة')}
              </span>
            )}
          </div>
        </div>
      </Card>
    </LocalizedLink>
  )
}
